module.exports = __webpack_public_path__ + "media/images/icon-nav-account-4a2c6bcb2951433759f3525817a7f16f.png";